import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorHandlingModule, NoAccessComponent, NotFoundComponent, PRODUCT_NAME_TOKEN } from '@skykick/core';
import { LinkedUserAccessDeniedComponent } from '@sharedservices/identity-auth-angular';

const APP_ROUTES: Routes = [
    {
        path: '',
        loadChildren: () => import('./pci/pci.module').then((m) => m.PciModule),
    },
    {
        path: 'no-access',
        component: NoAccessComponent,
    },
    {
        path: 'account-not-linked',
        title: 'ConnectWise - No Access',
        component: LinkedUserAccessDeniedComponent,
    },
    {
        path: '**',
        component: NotFoundComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(APP_ROUTES, {
            enableTracing: false,
            paramsInheritanceStrategy: 'always'
        }),
        ErrorHandlingModule,
    ],
    exports: [RouterModule],
    providers: [{ provide: PRODUCT_NAME_TOKEN, useValue: 'Partner Center' }],
})
export class AppRoutingModule { }
